import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export const isMultiSelectOptions = optionOrOptions => Array.isArray(optionOrOptions);

/**
 * This no op function is added so we can reuse it in the *.example.tsx files. Otherwise, we have to disable the eslint rule every time.
 * We can't add it to packages/amkt-common as that common package is deprecated README.md
 */
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => {};
const isOptionGroup = option => Object.hasOwn(option, 'options');

/**
 * If `addSelectedFirst` is true, this function returns the options with a new group for the selected options at the start,
 * and a group for the remaining ungrouped options at the end
 */
export const getGroupedOptions = _ref => {
  let {
    options,
    selectedOptions,
    addSelectedFirst
  } = _ref;
  // If there are no selections, return the options as they are
  if (!selectedOptions.length || !addSelectedFirst) {
    return options;
  }
  const newOptions = [];
  // Using a Set to efficiently check if the option was already added to `newOptions`
  const selectedOptionKeys = new Set(selectedOptions.map(option => option.value));

  // New group for the selected options
  const selectedOptionsGroup = {
    label: 'SELECTED',
    options: selectedOptions
  };

  // The `ALL` option group to display at the end
  const catchAllOptionGroup = {
    label: 'ALL',
    options: []
  };

  // Add the selected options first
  newOptions.push(selectedOptionsGroup);

  // Add the rest of the options, excluding the selected options
  options.forEach(optionOrOptionGroup => {
    if (isOptionGroup(optionOrOptionGroup)) {
      newOptions.push(_objectSpread(_objectSpread({}, optionOrOptionGroup), {}, {
        options: optionOrOptionGroup.options.filter(opt => !selectedOptionKeys.has(opt.value))
      }));
    } else if (!selectedOptionKeys.has(optionOrOptionGroup.value)) {
      catchAllOptionGroup.options.push(optionOrOptionGroup);
    }
  });
  if (catchAllOptionGroup.options.length > 0) {
    newOptions.push(catchAllOptionGroup);
  }
  return newOptions;
};
export const getSelectedFilterDefinition = (selectedFilterId, filterDefinitions) => {
  return filterDefinitions.find(filterDefinition => filterDefinition.filterId === selectedFilterId);
};
export const getOptionsForFilter = (filterId, filterOptions) => {
  var _filterOptions$filter;
  return filterId ? (_filterOptions$filter = filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions[filterId]) !== null && _filterOptions$filter !== void 0 ? _filterOptions$filter : [] : [];
};